<template lang="pug">
  .section-layout
    .section-filter
      .field-group.is-horizontal
        .field.name_keyword-wrapper
          label.label 关键字搜索
          custom-input(v-model="search_key" placeholder="按手机号查询", need-type='number', @keyupEnter="applyFilter")
        .field.name_keyword-wrapper
          label.label
          custom-input(v-model="order_code" placeholder="按订单号查询", @keyupEnter="applyFilter")
        .field.name_keyword-wrapper
          label.label 订单来源
          custom-select(:list="write_from" v-model="write_state" nameField="name")
        .field
          label.label 起止时间
          .field.is-horizontal
            date-picker.w_236(type="range", placeholder="请选择", v-model="time_range")
        .field
          a.button.primary(@click="applyFilter") 搜索
        .field
          a.button(@click="resetFilter") 重置
        .field
          a.button(@click="exportTable") 导出
    empty-page.m-t-40(v-if="!(list && list.length) && isInitiated", tip="当前没有核销列表数据")
    .content-wrapper.list-wrapper(v-if="list && list.length")
      .table-wrapper
        table.table
          thead
            tr
              td(v-for="th in theadConfig", v-text="th.name", :width="th.width")
          tbody(v-if="list.length")
            tr(v-for="(item, index) in list")
              td
                .simple-td {{item.purchase_type == 1 || item.purchase_type == 2 ? item.order_no : item.third_order_no}}
              td
                .multi-content-td
                  .content-item
                    span.left-image.inline
                      img(v-if="item.customer.avatar", :src="scaleImage(item.customer.avatar, 1, 16, 16)")
                      img(v-if="!item.customer.avatar", src="../../assets/user-avatar.png")
                    span(v-text="item.customer && item.customer.name")
                  .content-item
                    span(v-text="item.customer && item.customer.mobile")
                    span.content-divider.inline(v-if="item.customer && item.customer.vehicle && item.customer.vehicle.license_plate")
                    span(v-text="item.customer && item.customer.vehicle && item.customer.vehicle.license_plate || ''")
              td
                .simple-td(v-text="'￥' + accDiv(item.amount,100)")
              td
                .simple-td.overflow-ellipsis(v-text="item.write_off_store_name", :title="item.write_off_store_name")
              td
                .simple-td(v-text="item.operator ? item.operator : '--'")
              td
                .simple-td(v-text="item.mileage + 'km'")
              td
                .simple-td.m-r-5  {{item.write_off_at}}
              td
                .simple-td.m-r-5(v-if="item.purchase_type == 1", v-text="'门店'")
                .simple-td.m-r-5(v-if="item.purchase_type == 2", v-text="'平台'")
                .simple-td.m-r-5(v-if="item.purchase_type == 3", v-text="'第三方-天猫'")
                .simple-td.m-r-5(v-if="item.purchase_type == 4", v-text="'第三方-京东'")
                .simple-td.m-r-5(v-if="item.purchase_type == 5", v-text="'第三方-壳牌抖音小程序商城'")
                .simple-td.m-r-5(v-if="item.purchase_type == 6", v-text="'第三方-壳牌微信小程序商城'")
              td
                .operation-td
                  span.operation-link(@click="viewInfo(item)") 订单详情
                  span.operation-link(@click="showWriteOff(item)") 核销详情
      .tfoot(v-if="list.length")
        pagination(:pagination-data="paginationData", @input="paging")
    write-off-record-modal(v-if="is_show", :writeOffData="write_off_data" @input="close")
</template>

<script>
import EmptyPage from '@/components/generics/EmptyPage'
import Api from '@/mixins/modules/workbench'
import Pagination from '@/components/generics/Pagination'
import imageScale from '@/mixins/utilities/imageScale'
import CustomInput from '@/components/generics/form/CustomInput'
import CustomSelect from '@/components/generics/form/CustomSelect'
import DatePicker from '@/components/generics/form/DatePicker'
import WriteOffRecordModal from '@/components/workbench/model/WriteOffRecordModal'
import MathFun from '@/mixins/utilities/math'
import ExportApi from '@/mixins/modules/export'

export default {
  name: 'WriteOffRecords',
  mixins: [Api, imageScale, MathFun, ExportApi],
  components: {
    EmptyPage,
    Pagination,
    CustomInput,
    CustomSelect,
    DatePicker,
    WriteOffRecordModal,
  },
  data () {
    return {
      is_show: false, // 是否显示核销记录模态框
      isInitiated: false,
      search_key: '',
      order_code: '', // 订单号
      theadConfig: [
        {
          name: '订单号',
          width: '160',
        },
        {
          name: '车主信息',
          width: '160',
        },
        {
          name: '订单价格',
          width: '130',
        },
        {
          name: '核销门店',
          width: '160',
        },
        {
          name: '核销人',
          width: '100',
        },
        {
          name: '上次保养里程',
          width: '100',
        },
        {
          name: '服务时间',
          width: '100',
        },
        {
          name: '订单来源',
          width: '90',
        },
        {
          name: '操作',
          width: '150',
        }],
      list: [],
      paginationData: {
        current_page: 1,
        per_page: 20,
        last_page: 1,
        total: 0,
      },
      write_from: [
        {
          id: '',
          name: '全部',
        },
        {
          id: 1,
          name: '门店',
        },
        {
          id: 2,
          name: '平台',
        },
        {
          id: 3,
          name: '第三方-天猫',
        },
        {
          id: 4,
          name: '第三方-京东',
        },
        {
          id: 5,
          name: '第三方-壳牌抖音小程序商城',
        },
        {
          id: 6,
          name: '第三方-壳牌微信小程序商城',
        },
      ],
      is_search: false, // 是否搜索(翻页判断时用)
      write_state: {
        id: '',
        name: '',
      },
      write_off_data: null, // 核销详情数据
      start: '', // 开始时间
      end: '', // 结束时间
      time_range: '',
    }
  },
  methods: {
    formateDate () {
      if (this.time_range) {
        let tr = this.time_range.split(' 至 ')
        this.start = new Date(`${tr[0]} 00:00:00`).getTime() / 1000
        this.end = new Date(`${tr[1]} 23:59:59`).getTime() / 1000
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 导出
    exportTable () {
      this.formateDate()
      let params = {
        mobile: this.search_key,
        purchase_type: this.write_state.id,
        start_time: this.start,
        end_time: this.end,
        order_no: this.order_code,
      }
      // 去空
      Object.keys(params).forEach(key => {
        if (!params[key]) {
          delete params[key]
        }
      })
      this.exportOrderOff(params)
      // window.open(url)
    },
    // 搜索按钮
    applyFilter () {
      this.formateDate()
      this.time = this.start
      this.time2 = this.end
      this.is_search = true
      this.paginationData.current_page = 1
      this.getList()
    },
    // 重置
    resetFilter () {
      this.is_search = false
      this.paginationData.current_page = 1
      this.search_key = ''
      this.order_code = ''
      this.write_state = {
        id: '',
        name: '',
      }
      this.start = ''
      this.end = ''
      this.time_range = ''
      this.getList()
    },
    // 获取核销列表数据
    async getList () {
      // 去除搜索条件空格
      this.search_key = this.search_key.trim()
      this.order_code = this.order_code.trim()
      try {
        const { response, result } = await this.checkList({
          page: this.paginationData.current_page,
          per_page: this.paginationData.per_page,
          mobile: this.is_search ? this.search_key : '',
          order_no: this.is_search ? this.order_code : '',
          purchase_type: this.write_state.id,
          start_time: this.is_search && this.time ? this.time : '',
          end_time: this.is_search && this.time2 ? this.time2 : '',
        })
        if (response.status === 200 && result.code === 0) {
          this.list.splice(0, this.list.length, ...result.data)
          // console.log(this.list)
          this.paginationData = result.meta
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取核销列表失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取核销列表失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
      this.isInitiated = true
    },
    // 查看详情
    viewInfo (item) {
      // 记录列表页数
      this.$store.dispatch('setCurrentPageStorage', this.paginationData.current_page)
      this.$router.push({
        name: 'orderDetail',
        params: {
          id: item.order_id,
        },
      })
    },
    // 核销记录
    showWriteOff (item) {
      this.write_off_data = item.order_write_off_item
      this.is_show = true
    },
    close () {
      this.is_show = false
    },
    // 分页跳转
    paging (state) {
      this.paginationData = state
      this.getList()
    },
    // 确认核销完成的回调方法
    refreshList () {
      this.getList()
    },
  },
  mounted () {
    this.getList()
  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '--'
      } else {
        let date = new Date(val * 1000)
        let Y = date.getFullYear()
        let M = date.getMonth() + 1
        let D = date.getDate()
        let h = date.getHours()
        let m = date.getMinutes()
        let s = date.getSeconds()
        M = M < 10 ? '0' + M : M
        D = D < 10 ? '0' + D : D
        h = h < 10 ? '0' + h : h
        m = m < 10 ? '0' + m : m
        s = s < 10 ? '0' + s : s
        return `${Y}/${M}/${D} ${h}:${m}:${s}`
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
// @import '~@/stylus/mixins';
@import '~@/stylus/modules/table-sp'
.max-160
  max-width 160px !important
.reserve-operation-wrapper
  display flex
  align-items center
  flex-shrink 0
  justify-content center
  background-color #fff
.section-layout
  height calc(100% - 52px) !important
.bottom-image
  display inline-block
  width 20px
  height 20px
  margin-right 4px
  img
    height 100%
    width 100%
.margin
  margin 0 8px
  font-size 14px
.m-r-5
  margin-right 5px
.m-t-40
  margin-top 40px
.list-wrapper
  height calc(100% - 48px) !important
.operation-td
  width 150px
.overflow-ellipsis
  overflow hidden
  text-overflow ellipsis
  width 160px !important
.w_236
  width 236px
</style>



// WEBPACK FOOTER //
// src/components/workbench/WriteOffRecord.vue